import React, { useState } from 'react';
import styled from 'styled-components';
import HeadlessInput from '../../../shared/component/headless/input/HeadlessInput';
import { InputAuth, InputAuthMobile } from '../../../shared/component/headless/input/InputBody';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import searchIcon from '../../../asset/icon/see.png';
import searchNotIcon from '../../../asset/icon/see_not.png';
import { useDeviceStore } from '../../../shared/store/deviceStore';
import { DeviceType } from '../../../shared/enum/EnumRepository';

interface MoleculeInputProps {
  name: string;
  type?: string;
  inputName?: string;
  autoComplete?: string;
  value: string;
  handleChange: (value: string) => void;
  err: string | null;
  placeholder: string;
  nameVisible?: boolean;
  errVisible?: boolean;
  helperText?: React.ReactNode;
  reserveFeedbackSpace?: boolean;
}

const MoleculeAuthInput: React.FC<MoleculeInputProps> = ({
  name,
  type,
  inputName,
  autoComplete,
  value,
  handleChange,
  err,
  placeholder,
  nameVisible = true,
  errVisible = true,
  helperText,
  reserveFeedbackSpace = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = name.toLowerCase().includes('password') || name.includes('비밀번호');
  const { deviceType } = useDeviceStore();
  const hasError = Boolean(err);
  const feedbackText = hasError ? err : helperText;
  const shouldRenderFeedback = reserveFeedbackSpace || err !== null || helperText != null;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleWithPassswordVisibility = (value2: string) => {
    if (showPassword) {
      setShowPassword(false);
    }
    handleChange(value2);
  }

  return (
    <>
      {nameVisible && <InputName>{name}</InputName>}
      <InputWrapper>
        <HeadlessInput
          type={isPassword ? (showPassword ? 'text' : 'password') : type}
          inputName={inputName}
          autoComplete={autoComplete}
          value={value}
          handleChange={(e) => handleWithPassswordVisibility(e.target.value)}
          placeholder={placeholder}
          StyledInput={deviceType === DeviceType.MOBILE ? InputAuthMobile : InputAuth}
        />
        {isPassword && (
          <PasswordToggleWrapper>
            <UniversalIconBtn
              size="standard"
              border={false}
              isTransparent
              backgroundImg={showPassword ? searchIcon : searchNotIcon}
              onClick={togglePasswordVisibility}
            />
          </PasswordToggleWrapper>
        )}
      </InputWrapper>
      {errVisible && shouldRenderFeedback && (
        <FeedbackText $hasError={hasError} $reserveSpace={reserveFeedbackSpace}>
          {feedbackText ?? '\u00A0'}
        </FeedbackText>
      )}
    </>
  );
};

const InputWrapper = styled.div`  
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

const PasswordToggleWrapper = styled.div`
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
`;

const InputName = styled.h3`
  display: block;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_03_1};
`

const FeedbackText = styled.p<{ $hasError: boolean; $reserveSpace: boolean }>`
  height: ${({ $reserveSpace }) => ($reserveSpace ? '16px' : 'auto')};
  min-height: ${({ $reserveSpace }) => ($reserveSpace ? '16px' : '18px')};
  margin-bottom: ${({ $reserveSpace }) => ($reserveSpace ? '0' : '10px')};
  overflow: ${({ $reserveSpace }) => ($reserveSpace ? 'hidden' : 'visible')};
  color: ${({ theme, $hasError }) =>
    $hasError ? theme.colors.color_alert_red : theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;

export default MoleculeAuthInput;
